export enum IndividualGoalTrackingStatuses {
    NotSelected = 0,
    OnTrack = 1,
    AtRisk = 2,
    Blocked = 3
}
